import React from 'react'
import { IntroducePage } from '@/modules/landings/introduce/IntroducePage'
import styled from 'styled-components'

const IntroductionPageWrapper = styled.div``

const IntroductionPage = () => {
	return (
		<IntroductionPageWrapper>
			<IntroducePage />
		</IntroductionPageWrapper>
	)
}

export default IntroductionPage
